<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="13"
            categoryName="Stator"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'stator',
    components: { BaseInventory }
}
</script>
